"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.TelemetryProperties = exports.TemplateType = exports.Constants = void 0;
exports.Constants = {
    actionName: "arm/deploy", // DO NOT MODIFY the name
};
var TemplateType;
(function (TemplateType) {
    TemplateType["Json"] = "json";
    TemplateType["Bicep"] = "bicep";
})(TemplateType || (exports.TemplateType = TemplateType = {}));
exports.TelemetryProperties = {
    jsonTemplateCount: "json-template-count",
    bicepTemplateCount: "bicep-template-count",
};
//# sourceMappingURL=constant.js.map